"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrowHide = exports.rightArrowWrapper = exports.leftArrowWrapper = exports.arrowWrapper = void 0;

var react_1 = require("@emotion/react");

exports.arrowWrapper = react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: #000000b3;\n  opacity: 0;\n  z-index: 1;\n  transition: opacity 0.2s ease;\n\n  background-image: none !important;\n  cursor: pointer !important;\n  pointer-events: initial !important;\n"])));
exports.leftArrowWrapper = react_1.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  left: 12px;\n"])));
exports.rightArrowWrapper = react_1.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  right: 12px;\n"])));
exports.arrowHide = react_1.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  opacity: 0 !important;\n  pointer-events: none !important;\n"])));